import React, { useEffect, useState } from "react";

function CollectionsAdaHome() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://adawall.ma/php/api/collection.php")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (col) =>
            col.nomCategorie &&
            col.nomCategorie.toLowerCase() === "adahome"
        );
        setCollections(filtered);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

      useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cw-container" style={{ position: "relative", minHeight: "70vh" }}>
      {loading && (
        <div className="produits-loader">
          <div className="loader" />
          Chargement des collections...
        </div>
      )}
      <h1 className="cw-title">
        Nos Cossins & Poufs
        <span className="cw-title-underline"></span>
      </h1>
      <div className="cw-list">
        {collections.length === 0 && !loading ? (
          <div className="cw-empty">Aucune collection trouvée.</div>
        ) : (
          collections.map((col) => (
            <a
              href={`/collections/${col.idCollection}`}
              className="cw-card"
              key={col.idCollection}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="cw-img-wrapper">
                <img
                  src={`https://adawall.ma/uploads/${col.illustration || "assets/no-image.png"}`}
                  alt={col.nomCollection}
                  className="cw-img"
                />
              </div>
              <div className="cw-info">
                <div className="cw-name">{col.nomCollection}</div>
                <div className="cw-separator"></div>
                <div className="cw-desc">{col.description}</div>
              </div>
            </a>
          ))
        )}
      </div>
      <a
      href="https://wa.me/212664664692"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <img
        src="/assets/icons/whatsapp.png"
        alt="WhatsApp"
        style={{ width: 40, height: 40 }}
      />
    </a>
    </div>
    
  );
}

export default CollectionsAdaHome;